var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconJournal48Line = function SvgIconJournal48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H12.2a2.9 2.9 0 0 0-2.9 2.9v23.6a2.9 2.9 0 0 0 2.9 2.9h21.2a5.31 5.31 0 0 0 5.3-5.3V14.6a5.3 5.3 0 0 0-5.3-5.3Zm-11.1 3.4v5l-1-.54a1.72 1.72 0 0 0-1.61 0l-1 .54v-5h3.61Zm-9.6 0h2.65v5.88a2.889 2.889 0 0 0 1.41 2.49 2.85 2.85 0 0 0 2.86.07l.93-.5.92.5a2.909 2.909 0 0 0 4.28-2.56V12.7h3.6v22.6h-16.6l-.05-22.6Zm22.6 20.7a1.91 1.91 0 0 1-1.9 1.9h-.7V12.7h.7a1.91 1.91 0 0 1 1.9 1.9v18.8Z",
    fill: "current"
  })));
};
export default SvgIconJournal48Line;